import styled from "@emotion/styled";
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useFunnelNavigate } from 'src/common/hooks/useFunnelNavigate.hook';
import {
  ProductTypeCodeEnum, RootState, i18n, mediaQuery, openCallMeModal, useAppDispatch, useAppSelector
} from 'src/common';
import { useGetCalculationsQuery } from 'src/common/api/apollo/supplementary';
import { Divider, FilterCard, Flex, Loader, OfferV25Card, RequestAgentCard, Text } from 'src/components';
import { AppRoutes } from '../../_router/app.routes';

// /dopunsko-zdravstveno-osiguranje-b/ponude-pregled — v2.5 redesigned preview. A/B variant (DEV-4667).
// The original baseline is a separate page at /dopunsko-zdravstveno-osiguranje/ponude-pregled (offersPreview.page.tsx).

const FlexStyle = styled(Flex)({
  gap: '5px',

  [mediaQuery('mobile')]: {
    gap: '10px'
  },
})

const OffersPreviewPageB = () => {
  const { age } = useParams();
  const dispatch = useAppDispatch();

  const birthDate = age ? dayjs().subtract(parseInt(age, 10), 'year').format('YYYY-MM-DD') : undefined;
  const soId = useAppSelector((store: RootState) => store.model.offer.soId);

  const { bListToggle, oneTimeOffersToggle } = useAppSelector((store: RootState) => store.model.offer);

  const [bList, setBList] = useState(bListToggle);
  const [oneTime, setOneTime] = useState(oneTimeOffersToggle);

  const navigate = useFunnelNavigate();

  useEffect(() => {
    if (!age) {
      navigate(AppRoutes.CUSTOMER.fullPath);
    }

  }, [age, navigate]);

  const { loading, error, data } = useGetCalculationsQuery({
    variables: { input: { birthDate: birthDate || '', type: ProductTypeCodeEnum.DOPUNSKO, coverages: [] }, soId: soId ?? '' },
    skip: !birthDate,
  });

  useEffect(() => {
    if (!birthDate) {
      navigate(AppRoutes.CUSTOMER.fullPath);
    }
  }, [birthDate, navigate]);

  if (loading) return <Loader page />;
  if (error) navigate(AppRoutes.CUSTOMER.fullPath);

  // Destrukturiranje podataka
  const { getCalculations: webCalculationsSupplementary } = data || {};

  if (!webCalculationsSupplementary) return null;

  // Provjera da li treba filtrirati podatke
  const filteredOffers = bList ?
    webCalculationsSupplementary?.filter((offer: any) =>
      offer.includedInPrice.some((coverage: any) => coverage.label === "B lista lijekova")
    ) :
    webCalculationsSupplementary?.filter((offer: any) =>
      !offer.includedInPrice.some((coverage: any) => coverage.label === "B lista lijekova")
    )

  // Sortiranje podataka po cijeni
  const sortedOffers = filteredOffers.slice().sort((a: any, b: any) => {
    if (oneTime) {
      return a.price.totalOneTimePayment - b.price.totalOneTimePayment;
    }
    return a.price.totalWithInstallments - b.price.totalWithInstallments;
  });

  const onBListToggleChange = (checked: boolean) => {
    setBList(checked);
  };

  const onOneTimeToggleChange = (checked: boolean) => {
    setOneTime(checked);
  };

  return (
    <Flex vertical gap={24}>
      <Text type="xLarge" bold>{i18n.t('pages.offersPage.title')}</Text>
      <FlexStyle vertical>
        <FilterCard title={i18n.t('pages.offersPage.bListFilter')} description={i18n.t('pages.offersPage.bListFilterDescription')} onToggleChange={(checked) => onBListToggleChange(checked)} checked={bList} />
        <FilterCard title={i18n.t('pages.offersPage.oneTimeFilter')} description={i18n.t('pages.offersPage.oneTimeFilterDescription')} onToggleChange={(checked) => onOneTimeToggleChange(checked)} checked={oneTime} />
      </FlexStyle>
      <Divider dashed />
      {sortedOffers?.map((offer: any) => (
        <OfferV25Card key={offer.productCode} offer={offer} oneTimeToggle={oneTime} bListToggle={bList} showSelectButton={false} />
      ))}
      <RequestAgentCard onButtonClick={() => dispatch(openCallMeModal())} />
    </Flex>
  );
}

export default OffersPreviewPageB;
